// extracted by extract-css-chunks-webpack-plugin
module.exports = {"panel":"Xsk9cK175UGG","active":"AserpYoAQvMp"};